// Responsive design tokens for the vending machine interface
export const responsiveSpacing = {
  xs: 'clamp(4px, 0.5vw, 8px)',
  sm: 'clamp(8px, 1vw, 16px)',
  md: 'clamp(12px, 1.5vw, 24px)',
  lg: 'clamp(16px, 2vw, 32px)',
  xl: 'clamp(24px, 3vw, 48px)',
  xxl: 'clamp(32px, 4vw, 64px)',
  // Page-level padding (MUI sx fragment) used by full-page tabs (e.g. Settings).
  pagePadding: { p: { xs: 2, sm: 3, md: 4 } }
};

export const responsiveTypography = {
  h1: {
    fontSize: 'clamp(24px, 3vw, 32px)',
    fontWeight: 700,
    lineHeight: 1.2,
    color: '#1a1a1a'
  },
  h2: {
    fontSize: 'clamp(20px, 2.5vw, 24px)',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#1a1a1a'
  },
  h3: {
    fontSize: 'clamp(16px, 2vw, 18px)',
    fontWeight: 500,
    lineHeight: 1.4,
    color: '#1a1a1a'
  },
  body: {
    fontSize: 'clamp(14px, 1.5vw, 16px)',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#1a1a1a'
  },
  bodySecondary: {
    fontSize: 'clamp(14px, 1.5vw, 16px)',
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#6b7280'
  },
  caption: {
    fontSize: 'clamp(10px, 1.1vw, 14px)',
    fontWeight: 400,
    lineHeight: 1.4,
    color: '#6b7280'
  },
  small: {
    fontSize: 'clamp(9px, 1.1vw, 12px)',
    fontWeight: 400,
    lineHeight: 1.3,
    color: '#6b7280'
  }
};

export const responsiveBreakpoints = {
  sidebarShrink: '1000px',  // Reduce sidebar from 480px to 360px
  compactMode: '700px',     // Switch to compact layout
  minViable: '500px'        // Below this, show overflow warning
};

// Responsive sidebar configuration
export const getSidebarConfig = () => ({
  width: 'clamp(280px, 28vw, 380px)',
  paddingOffset: 'clamp(312px, 30vw, 412px)' // width + 32px gap
});

// Safety constraints
export const constraints = {
  minCellSize: '30px',     // Never smaller for usability
  minFontSize: '9px',      // Never smaller for readability  
  minSidebarWidth: '280px', // Functional minimum
  minContainerWidth: '400px' // Below this shows warning
};

// Grid responsive sizing
export const getGridConfig = () => ({
  cellMinHeight: 'clamp(30px, 3.5vw, 50px)',
  gap: 'clamp(4px, 0.6vw, 16px)',
  containerMaxWidth: 'clamp(600px, 80vw, 1000px)',
  containerPadding: 'clamp(16px, 2vw, 32px)'
});